import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type Props = {
  color?: string
  content: string
  toolTip?: string
}

export const AncientBadge: React.FC<Props> = ({color, content, children, toolTip}) => {
  return (
    <OverlayTrigger
      show={toolTip != undefined && toolTip != ''}
      placement='top'
      overlay={<Tooltip id='button-tooltip-2'>{toolTip}</Tooltip>}
    >
      <div className={'badge fw-bolder ' + (color == undefined ? 'badge-light' : color)}>
        {content}
      </div>
    </OverlayTrigger>
  )
}
